/*global jQuery */
;(function ($, window, document, undefined) {
  'use strict';
  var $document,
      $toggleButton,
      $docElement,
      eventAction = 'serviceflap/update',
      dataSelector = 'data-serviceflap',
      openState = 'serviceflapOpen',
      closeState = 'serviceflapClosed',

      init = function () {

        $document = $(document);
        $docElement = $(document.documentElement);
        $toggleButton = $('.js-serviceflap-toggle');

        // listen on menu change
        // $document.on(eventAction, function(){
        //   var serviceflapData = $docElement.attr(dataSelector);
        //
        //   // change aria labels
        //   if(serviceflapData === openState) {
        //     $toggleButton.attr('aria-expanded', 'false');
        //   } else {
        //     $toggleButton.attr('aria-expanded', 'true');
        //   }
        // });

        // toggle click handler
        $document.on('click', '.js-serviceflap-toggle', function (e) {

          e.preventDefault();

          var serviceflapData = $docElement.attr(dataSelector);

          if (serviceflapData === openState) {
            $docElement.attr(dataSelector,closeState);
            $document.triggerHandler(eventAction);
          } else {
            $docElement.attr(dataSelector,openState);
            $document.triggerHandler(eventAction);
          }
        });

        $document.on('click', '.js-serviceflap-link', function(e) {
          var serviceflapData = $docElement.attr(dataSelector);

          if (serviceflapData === openState) {

          } else {
            e.preventDefault();
            $docElement.attr(dataSelector,openState);
            $document.triggerHandler(eventAction);
          }
        });
      };
  init();


})(jQuery, window, document);
